import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { HasClassName } from '../../component-utils';
import { useSelector } from '../../hook-utils';
import { TaskItemAction } from '../../model';
import { actions } from '../../store';
import { selectEmail } from '../../store/reducers/emails';
import Modal from '../Modal';
import { CallViewByItemDetails } from './CallDetailsPanel';
import { EmailEditor, EmailViewerRender } from './EmailView';
import './EmailViewPanel.scss';
import { selectEmailAccount } from '../../store/reducers/queueEmails';

export interface ShowEmailState {
  emailId?: string
  mediaId?: string
  queueId?: string
  reply: boolean,
}

interface Props extends HasClassName {
  emailId: string
  accountId?: string,
}

export default function EmailViewPanel({ className, emailId, accountId }: Props) {
  const account = useSelector(s => accountId && selectEmailAccount(s, accountId))
  const email = useSelector(s => selectEmail(s, emailId))
  const dispatch = useDispatch()

  useEffect(() => {
    if (email) { return }

    dispatch(actions.fetchEmailReadRequest(emailId, undefined, account ? account.emailAddress : undefined))
  }, [account, dispatch, email, emailId])

  if (!email) {
    return <div className={className}>Loading...</div>
  }

  if (email.reply) {
    return <EmailEditor className={className} mediaId={emailId} />
  } else {
    return <EmailViewerRender className={className} mediaId={emailId} />
  }
}

export function EmailViewPopup({ onClose, itemAction, className, emailId }: Props & { onClose: () => void, itemAction?: TaskItemAction }) {
  //const dispatch = useDispatch()

  function handleClose() {
    //should do this but need to check if it's active in agent view before doing it
    //dispatch(actions.removeMediaItem(emailId))

    onClose()
  }


  return <Modal isOpen={true} className='EmailViewPopup' >
    <CallViewByItemDetails itemId={emailId} itemType='EMAIL' itemAction={!itemAction ? TaskItemAction.none : itemAction} onClose={handleClose} />
    <EmailViewPanel emailId={emailId} className={classNames('EmailViewPopupBody', className)} />
  </Modal>
}

